<template>
  <div id="per_center">
    <div class="main">
      <div class="main_top">
        <div class="main_top_wrapper">
          <div class="help_title">如何一键玩转游严选</div>
          <div>
            <el-input
              placeholder="请输入问题关键词"
              clearable
              @keydown.enter.native="handleSearch"
              v-model.trim="query.matchCon">
              <span slot="prefix">
                <img src="@/assets/image/HelpCenter/search.png">
              </span>
            </el-input>
          </div>
        </div>
      </div>
      <div class="main_content">
        <!-- <router-view></router-view> -->
        <div class="hellp_search">
          <div class="search_wrapper">
            <div class="search_top">
              <div class="top_left">
                <router-link :to="{name:'helpCenter'}">返回</router-link>
                <i class="el-icon-arrow-right"></i>
                <span>搜索结果</span>
              </div>
              <!-- <div class="top_right">找不到答案？<a>点击联系在线客服<i class="el-icon-arrow-right"></i><i class="el-icon-arrow-right"></i></a></div> -->
            </div>
            <div class="search_list" v-if="helpList.length">
              <div class="search_list_item" v-for="item in helpList" :key="item.id">
                <router-link tag="a" target="_blank" class="item_title" :to="{name: 'helpDetail',query: {id: item.id,cat_id: item.cat_id}}"><span v-html="item.title"></span> <i class="el-icon-arrow-right"></i></router-link>
                <div class="item_path">全部问题 / {{ item.cat_name }}</div>
                <div class="item_con" v-html="item.description"></div>
              </div>
            </div>
            <div class="search_empty" v-else>
              <empty-state
                title="暂无搜索结果"
                description="换个关键词试试，或返回帮助中心浏览全部问题"
                icon="el-icon-search">
              </empty-state>
            </div>
          </div>
          <common-pagination
            v-if="totalCount > query.pageSize"
            class="contract-pages"
            @current-change="handleCurrentChange"
            :current-page.sync="query.page"
            :page-size="query.pageSize"
            :total="totalCount"
          >
          </common-pagination>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import { apiHelpCenter, apiHelpDetail, apiHelpSearch } from "@/request/API";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";
export default {
  name: 'HelpSearch',
  components: {
    CommonPagination,
    EmptyState
  },
  data() {
    return {
      query: {
        matchCon: '',
         // 默认显示第几页
        page: 1,
        // 默认每页显示的条数
        pageSize: 10,
      },
      // 总条数，根据接口获取数据长度
      totalCount: 0,
      helpList: []
    }
  },
  created() {
    this.query.matchCon = this.$route.query.keyWord
    this.getHelpData()
  },
  mounted() {
    // this.$on('getSearch',(val) => {
    //   this.query.matchCon
    //   this.getHelpData()
    // })
  },
  methods: {
    handleSearch() {
      this.getHelpData()
    },
    handleCurrentChange(val) {
      this.query.page = val
      this.getHelpData()
    },
    getHelpData() {
      apiHelpSearch(this.query).then(res => {
        this.helpList = res.data.list
        this.totalCount = res.data.total
      })
    }
  },
}
</script>

<style lang="less" scoped>
#per_center {
  width: 1200px;
  margin-top: 14px;
  display: flex;
  flex-direction: row;
  min-height: 644px;
  background: var(--bg-page, #F7F5F2);

  .main {
    width: 1200px;
    min-height: 644px;
    padding-bottom: 28px;
    background: var(--bg-card, #FFFFFF);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    overflow: hidden;

    .main_top {
      height: 250px;
      background:
        linear-gradient(135deg, rgba(26, 29, 36, 0.88) 0%, rgba(26, 29, 36, 0.72) 100%),
        url("../../assets/image/HelpCenter/bg_top.png") center top no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      .main_top_wrapper {
        position: relative;
        z-index: 1;
        width: 500px;
        text-align: center;
        padding-top: 34px;

        .help_title {
          margin-bottom: 22px;
          font-size: 28px;
          line-height: 38px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: #FFFFFF;
          text-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);
        }

        /deep/ .el-input {
          width: 100%;
        }

        /deep/ .el-input__inner {
          height: 52px;
          border-radius: 4px;
          padding-right: 44px;
          padding-left: 55px;
          font-size: 15px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-main, #111827);
          border: 1px solid rgba(255, 255, 255, 0.68);
          background: rgba(255, 255, 255, 0.96);
          box-shadow: 0 14px 34px rgba(26, 29, 36, 0.18);
          transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

          &:hover {
            border-color: #FFFFFF;
            background: #FFFFFF;
            box-shadow: 0 18px 40px rgba(26, 29, 36, 0.24);
          }

          &:focus {
            border-color: var(--primary, #FF5A1F);
            background: #FFFFFF;
            box-shadow: none;
          }
        }

        /deep/ .el-input__prefix {
          width: 18px;
          height: 18px;
          top: calc(50% - 9px);
          left: 26px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .main_content {
      position: relative;
      top: -58px;
      left: 50%;
      width: 1036px;
      transform: translateX(-50%);
      z-index: 1;
    }
  }
}

.hellp_search {
  .search_wrapper {
    min-height: 465px;
    padding: 28px 30px 30px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

    .search_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 32px;
      margin-bottom: 14px;
      padding-bottom: 18px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);

      .top_left {
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 22px;
        color: var(--text-muted, #9AA0AC);

        a {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 58px;
          height: 28px;
          padding: 0 14px;
          background: transparent;
          border: 1px solid var(--text-main, #1A1D24);
          border-radius: 3px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #1A1D24);
          box-sizing: border-box;
          transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;

          &:hover {
            color: #FFFFFF;
            background: var(--text-main, #1A1D24);
            border-color: var(--text-main, #1A1D24);
          }
        }

        i {
          margin: 0 10px;
          font-size: 13px;
          color: var(--text-muted, #9AA0AC);
        }

        span {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-main, #111827);
        }
      }

      .top_right {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-main, #111827);

        a {
          color: var(--primary, #FF7A1A);
          cursor: pointer;

          i {
            width: 6px;
          }
        }
      }
    }

    .search_list {
      .search_list_item {
        min-height: 108px;
        padding: 18px 20px;
        border-radius: 4px;
        box-sizing: border-box;
        transition: background 0.2s ease, transform 0.2s ease;

        &:hover {
          background: var(--bg-section, #F7F5F2);

          .item_title {
            color: var(--primary, #FF5A1F);
          }
        }

        & + .search_list_item {
          border-top: 1px solid var(--border-soft, #E8E4DE);
        }

        .item_title {
          display: inline-flex;
          align-items: center;
          max-width: 100%;
          font-size: 16px;
          line-height: 24px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #111827);
          cursor: pointer;
          transition: color 0.2s ease;

          span {
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          i {
            flex: 0 0 auto;
            margin-left: 4px;
            font-size: 14px;
          }
        }

        .item_path {
          margin: 7px 0 8px;
          font-size: 14px;
          line-height: 20px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
        }

        .item_con {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          position: relative;
          line-height: 22px;
          max-height: 44px;
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }

    .search_empty {
      height: 340px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .contract-pages {
    margin-top: 2px;
  }
}
</style>
